import React, { useState, useEffect } from 'react';
import { header as headerItems } from '../../../json/layout/Header';
import './headerDos.css';

const HeaderDos = () => {
  const [scrolled, setScrolled] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(-1);
  const currentPath = window.location.pathname;

  // Scroll & resize
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  // -----------------------
  // Helpers de ruta base
  // -----------------------
  const detectionBase = item =>
    item.link ||
    (item.submenu && item.submenu.length > 0
      ? '/' + item.submenu[0].link.split('/')[1]
      : '');

  const hrefBase = item => item.link || '#';

  const isParentActive = item => {
    const base = detectionBase(item);
    return currentPath === base || currentPath.startsWith(base + '/');
  };

  // -----------------------
  // Device flags
  // -----------------------
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;
  const collapseNav = isMobile || isTablet;

  const toggleSubmenu = idx =>
    setActiveSubmenu(prev => (prev === idx ? -1 : idx));
  const toggleMenu = () => {
    if (isMenuOpen) setActiveSubmenu(-1);
    setIsMenuOpen(prev => !prev);
  };

  // Logo
  const logoUrl = collapseNav
    ? '/assets/imgs/LOGO2.svg'
    : scrolled
      ? '/assets/imgs/LOGO2.svg'
      : '/assets/imgs/LOGO.svg';

  return (
    <header
      className={`header-dos ${scrolled ? 'scrolled' : ''} ${collapseNav ? 'mobile' : ''
        }`}
    >
      <a href="/" className="header-logo-ref">
        <div
          className="header-logo"
          style={{
            backgroundImage: `url('${logoUrl}')`,
            transition: 'background-image 0.3s ease',
          }}
        />
      </a>
      {/* === DESKTOP === */}
      {!collapseNav && (
        <nav>
          <ul className="nav-desktop">
            {headerItems.map((item, idx) => {
              const parentActive = isParentActive(item);
              return (
                <li
                  key={idx}
                  className="nav-item"
                  onMouseEnter={() => item.submenu && setActiveSubmenu(idx)}
                  onMouseLeave={() => item.submenu && setActiveSubmenu(-1)}
                >
                  <a
                    href={hrefBase(item)}
                    className={`link${parentActive ? ' active' : ''}`}
                    onClick={e => !item.link && e.preventDefault()}
                  >
                    {item.nombre}
                  </a>
                  {item.submenu &&
                    activeSubmenu === idx && (
                      <ul className="submenu-desktop">
                        {item.submenu.map((sub, sidx) => (
                          <li
                            key={sidx}
                            className={`submenu-item${currentPath === sub.link ? ' active' : ''
                              }`}
                          >
                            <a
                              href={sub.link}
                              className={`sub-link${currentPath === sub.link ? ' active' : ''
                                }`}
                            >
                              {sub.nombre}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                </li>
              );
            })}
          </ul>
        </nav>
      )}
      {/* === MOBILE & TABLET === */}
      {collapseNav && (
        <>
          <div
            className={`hamburger ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
          >
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
          </div>
          {isMenuOpen && (
            <>
              <div className="mobile-menu">
                <ul className="nav-mobile">
                  {headerItems.map((item, idx) => {
                    const parentActive = isParentActive(item);
                    const open = activeSubmenu === idx || parentActive;
                    return (
                      <li
                        key={idx}
                        className={`menu-item-mobile${open ? ' open' : ''}`}
                      >
                        <a
                          href={hrefBase(item)}
                          className={`link${parentActive ? ' active' : ''}`}
                          onClick={e => {
                            if (item.submenu) {
                              e.preventDefault();
                              toggleSubmenu(idx);
                            }
                          }}
                        >
                          {item.nombre}
                        </a>
                        {item.submenu && open && (
                          <ul className="submenu-mobile">
                            {item.submenu.map((sub, sidx) => (
                              <li key={sidx} className="submenu-item">
                                <a
                                  href={sub.link}
                                  className={`link${currentPath === sub.link
                                      ? ' active'
                                      : ''
                                    }`}
                                >
                                  {sub.nombre}
                                </a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="nav-backdrop" onClick={toggleMenu} />
            </>
          )}
        </>
      )}
    </header>
  );
};

export default HeaderDos;